import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { MultilineTeaserField } from '@/features/profile-setting/components/organization-edit/MultilineTeaserField';
import type { OrganizationEditStyleSheet } from '@/features/profile-setting/components/organization-edit/organizationEditFormStyles';
import type { ExtensionSectionProps } from '@/features/profile-setting/components/organization-extensions/types';
import { MAYOR_GREETING_MAX_LENGTH } from '@/features/profile-setting/constants/organization';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';

type Props = ExtensionSectionProps & {
  styles: OrganizationEditStyleSheet;
};

export const TerritorialAuthorityEditSection: FC<Props> = ({
  namePrefix,
  disabled,
  styles
}) => {
  const { t } = useTranslation(LocalizationNameSpace.PROFILE_SETTING, {
    keyPrefix: 'screens.organization-edit'
  });
  const name = `${namePrefix}.mayorGreeting` as const;

  return (
    <MultilineTeaserField
      name={name}
      sectionTitle={t('fields.mayorGreeting')}
      placeholder={t('placeholders.mayorGreeting')}
      editorTitle={t('mayorGreetingEditor.title')}
      editorPlaceholder={t('mayorGreetingEditor.placeholder')}
      maxLength={MAYOR_GREETING_MAX_LENGTH}
      isPending={disabled ?? false}
      styles={styles}
    />
  );
};
